<template>
    <component :is="comp" :send-redpack="sendRedpack" :is-preview="isPreview" v-if="comp" />
</template>

<script >
import { computed, defineProps } from 'vue-demi';
import { COMPONENT_LIST } from './config';
const __sfc_main = {};
__sfc_main.props = ['redpacketStyle', 'sendRedpack', 'isPreview'];
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const comp = computed(() => {
    const component = COMPONENT_LIST.find(item => item.value === props.redpacketStyle);
    return component ? component.component : null;
  });
  return {
    comp
  };
};
export default __sfc_main;
</script>
